import React, { useState } from 'react';
import { Search, Filter, ArrowUp, Clock, Users as UsersIcon, Briefcase, CheckSquare, ChevronDown } from 'lucide-react';

const RealEstateHR = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterDepartment, setFilterDepartment] = useState('Property Management');

  const hiringPipeline = [
    {
      role: 'Property Manager',
      totalApplications: 88,
      newApplied: 18,
      screening: 12,
      interview: 8,
      test: '-',
      hired: '-'
    },
    {
      role: 'Leasing Agent',
      totalApplications: 65,
      newApplied: 15,
      screening: 10,
      interview: 5,
      test: '-',
      hired: '-'
    },
    {
      role: 'Maintenance Technician',
      totalApplications: 52,
      newApplied: 12,
      screening: 8,
      interview: 4,
      test: '-',
      hired: '-'
    }
  ];

  const trackedTime = [
    { name: 'Jane Cooper', id: '43392', role: 'UI Designer', type: 'Fulltime', time: '4:03:23', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop' },
    { name: 'Wade Warren', id: '12456', role: 'Product Manager', type: 'Fulltime', time: '5:12:45', avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop' },
    { name: 'Esther Howard', id: '78901', role: 'Developer', type: 'Contract', time: '3:45:12', avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop' },
    { name: 'Robert Fox', id: '56789', role: 'Designer', type: 'Fulltime', time: '6:20:15', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop' }
  ];

  const attendanceRecords = [
    { name: 'Jane Cooper', role: 'Property Manager', clockIn: '09:00am', duration: '4:03:23', clockOut: '01:03pm', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop' },
    { name: 'Wade Warren', role: 'Leasing Agent', clockIn: '08:45am', duration: '5:12:45', clockOut: '02:57pm', avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop' },
    { name: 'Esther Howard', role: 'Maintenance Tech', clockIn: '09:15am', duration: '3:45:12', clockOut: '01:00pm', avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop' },
    { name: 'Robert Fox', role: 'Sales Agent', clockIn: '08:30am', duration: '6:20:15', clockOut: '02:50pm', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop' }
  ];

  const filteredAttendance = attendanceRecords.filter(record =>
    record.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    record.role.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-black text-white p-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-4xl font-bold mb-1">HR</h1>
        <p className="text-gray-400 text-sm">Human Resources management and employee tracking</p>
      </div>

      {/* Top Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
        {/* Total Members */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <p className="text-gray-400 text-sm mb-2">Total Members</p>
          <p className="text-5xl font-bold mb-2">30</p>
          <div className="flex items-center gap-2 text-sm text-green-400">
            <ArrowUp size={16} />
            <span>+2 members</span>
          </div>
        </div>

        {/* Clock-in */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <p className="text-gray-400 text-sm mb-2">Clock-in</p>
          <p className="text-5xl font-bold mb-2">20</p>
          <p className="text-sm text-yellow-500">2 members late</p>
        </div>

        {/* Clock-out */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <p className="text-gray-400 text-sm mb-2">Clock-out</p>
          <p className="text-5xl font-bold">2</p>
        </div>

        {/* Absent */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <p className="text-gray-400 text-sm mb-2">Absent</p>
          <p className="text-5xl font-bold">0</p>
        </div>
      </div>

      {/* Middle Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        {/* Hiring Pipeline */}
        <div className="lg:col-span-2 bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold">Hiring</h2>
            <div className="flex items-center gap-3">
              <button className="flex items-center gap-2 px-3 py-2 bg-gray-800 rounded text-sm hover:bg-gray-700 transition-all">
                {filterDepartment} <ChevronDown size={16} />
              </button>
              <button className="text-sm text-blue-400 hover:text-blue-300">VIEW ALL &gt;</button>
            </div>
          </div>

          {/* Pipeline Table */}
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-800">
                  <th className="text-left py-3 px-2 text-xs font-semibold text-gray-400">ROLE</th>
                  <th className="text-left py-3 px-2 text-xs font-semibold text-gray-400">NEW APPLIED</th>
                  <th className="text-left py-3 px-2 text-xs font-semibold text-gray-400">SCREENING</th>
                  <th className="text-left py-3 px-2 text-xs font-semibold text-gray-400">INTERVIEW</th>
                  <th className="text-left py-3 px-2 text-xs font-semibold text-gray-400">TEST</th>
                  <th className="text-left py-3 px-2 text-xs font-semibold text-gray-400">HIRED</th>
                </tr>
              </thead>
              <tbody>
                {hiringPipeline.map((job, index) => (
                  <tr key={index} className="border-b border-gray-800">
                    <td className="py-4 px-2">
                      <p className="font-semibold">{job.role}</p>
                      <p className="text-xs text-gray-400">Total Application: {job.totalApplications}</p>
                    </td>
                    <td className="py-4 px-2">
                      <span className="px-3 py-1.5 bg-blue-600 rounded text-xs">
                        {job.newApplied} Candidates
                      </span>
                    </td>
                    <td className="py-4 px-2">
                      <span className="px-3 py-1.5 bg-purple-600 rounded text-xs">
                        {job.screening} Candidates
                      </span>
                    </td>
                    <td className="py-4 px-2">
                      <span className="px-3 py-1.5 bg-pink-600 rounded text-xs">
                        {job.interview} Candidates
                      </span>
                    </td>
                    <td className="py-4 px-2 text-gray-500 text-sm">{job.test}</td>
                    <td className="py-4 px-2 text-gray-500 text-sm">{job.hired}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Jobs Summary */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <h2 className="text-xl font-bold mb-6">Jobs Summary</h2>
          
          {/* Donut Chart */}
          <div className="relative w-48 h-48 mx-auto mb-6">
            <svg viewBox="0 0 100 100" className="transform -rotate-90">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#6366f1" strokeWidth="12" strokeDasharray="150.8 251.2" />
              <circle cx="50" cy="50" r="40" fill="none" stroke="#eab308" strokeWidth="12" strokeDasharray="50.24 351.76" strokeDashoffset="-150.8" />
              <circle cx="50" cy="50" r="40" fill="none" stroke="#ec4899" strokeWidth="12" strokeDasharray="45.216 356.784" strokeDashoffset="-201.04" />
              <circle cx="50" cy="50" r="40" fill="none" stroke="#10b981" strokeWidth="12" strokeDasharray="37.68 364.32" strokeDashoffset="-246.256" />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <p className="text-3xl font-bold">133</p>
              <p className="text-xs text-gray-400">TOTAL JOBS</p>
            </div>
          </div>

          {/* Job Metrics */}
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-green-500"></div>
                <span className="text-sm text-gray-400">Published</span>
              </div>
              <span className="font-semibold">80</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                <span className="text-sm text-gray-400">On Hold</span>
              </div>
              <span className="font-semibold">20</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-pink-500"></div>
                <span className="text-sm text-gray-400">Internal</span>
              </div>
              <span className="font-semibold">18</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-purple-500"></div>
                <span className="text-sm text-gray-400">Closed</span>
              </div>
              <span className="font-semibold">15</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Tracked Time */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <h2 className="text-xl font-bold mb-4">Tracked Time</h2>
          
          {/* Total Time Display */}
          <div className="mb-6">
            <p className="text-5xl font-bold mb-3">100:20:03</p>
            <div className="flex items-center gap-6 text-sm text-gray-400">
              <div className="flex items-center gap-2">
                <UsersIcon size={16} />
                <span>18 Members</span>
              </div>
              <div className="flex items-center gap-2">
                <Briefcase size={16} />
                <span>4 Projects</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckSquare size={16} />
                <span>5 Tasks</span>
              </div>
            </div>
          </div>

          {/* Time Records */}
          <div className="space-y-4 max-h-80 overflow-y-auto">
            {trackedTime.map((record, index) => (
              <div key={index} className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <img src={record.avatar} alt={record.name} className="w-10 h-10 rounded-full object-cover" />
                  <div>
                    <p className="font-semibold text-sm">{record.name}</p>
                    <p className="text-xs text-gray-400">{record.id} {record.role} • {record.type}</p>
                  </div>
                </div>
                <p className="font-semibold">{record.time}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Attendance Details */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <h2 className="text-xl font-bold mb-4">Attendance Details</h2>
          
          {/* Search and Filters */}
          <div className="flex items-center gap-3 mb-4">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2 bg-gray-900 border border-gray-700 rounded text-sm text-white placeholder-gray-400 focus:outline-none focus:border-gray-600"
              />
            </div>
            <button className="p-2 bg-gray-800 rounded hover:bg-gray-700 transition-all">
              <Filter size={16} />
            </button>
            <button className="px-3 py-2 bg-gray-800 rounded text-xs hover:bg-gray-700 transition-all">
              Short
            </button>
          </div>

          {/* Attendance Table */}
          <div className="space-y-3 max-h-96 overflow-y-auto">
            <div className="grid grid-cols-2 gap-4 pb-2 border-b border-gray-800">
              <p className="text-xs font-semibold text-gray-400">NAME</p>
              <p className="text-xs font-semibold text-gray-400">CLOCK-IN & CLOCK-OUT</p>
            </div>
            {filteredAttendance.map((record, index) => (
              <div key={index} className="grid grid-cols-2 gap-4 py-3 border-b border-gray-800">
                <div className="flex items-center gap-3">
                  <img src={record.avatar} alt={record.name} className="w-10 h-10 rounded-full object-cover" />
                  <div>
                    <p className="font-semibold text-sm">{record.name}</p>
                    <p className="text-xs text-gray-400">{record.role}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <Clock size={14} className="text-gray-400" />
                  <span>{record.clockIn}</span>
                  <span className="text-gray-400">→</span>
                  <span>{record.duration}</span>
                  <span className="text-gray-500">N/A</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealEstateHR;
